/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputCreateHistoryEvent
 */
export interface InputCreateHistoryEvent {
    /**
     * 
     * @type {string}
     * @memberof InputCreateHistoryEvent
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof InputCreateHistoryEvent
     */
    eventTime: string;
    /**
     * 
     * @type {number}
     * @memberof InputCreateHistoryEvent
     */
    teamId: number;
    /**
     * 
     * @type {string}
     * @memberof InputCreateHistoryEvent
     */
    video?: string;
    /**
     * 
     * @type {number}
     * @memberof InputCreateHistoryEvent
     */
    zoneId: number;
}

/**
 * Check if a given object implements the InputCreateHistoryEvent interface.
 */
export function instanceOfInputCreateHistoryEvent(value: object): boolean {
    if (!('eventTime' in value)) return false;
    if (!('teamId' in value)) return false;
    if (!('zoneId' in value)) return false;
    return true;
}

export function InputCreateHistoryEventFromJSON(json: any): InputCreateHistoryEvent {
    return InputCreateHistoryEventFromJSONTyped(json, false);
}

export function InputCreateHistoryEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputCreateHistoryEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'eventTime': json['eventTime'],
        'teamId': json['teamId'],
        'video': json['video'] == null ? undefined : json['video'],
        'zoneId': json['zoneId'],
    };
}

export function InputCreateHistoryEventToJSON(value?: InputCreateHistoryEvent | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'eventTime': value['eventTime'],
        'teamId': value['teamId'],
        'video': value['video'],
        'zoneId': value['zoneId'],
    };
}

